import { render, staticRenderFns } from "./fetichismo.vue?vue&type=template&id=085ea178&scoped=true"
import script from "./fetichismo.vue?vue&type=script&lang=js"
export * from "./fetichismo.vue?vue&type=script&lang=js"
import style0 from "./fetichismo.vue?vue&type=style&index=0&id=085ea178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ea178",
  null
  
)

export default component.exports